import Button from "components/button";
import { useEffect, useState } from "react";
import intl from "react-intl-universal";
import { useProductionPlanSupplierContext } from "../../context";
import type { ProductionPlanSupplierFilters } from "../../types";
import ProductionPlanSupplierFilterFields from "../production-plan-supplier-filter-fields";
import * as S from "./styled";

const ProductionPlanSupplierFilter = () => {
  const {
    filters,
    filterOptionsLoading,
    supplierOptions,
    materialOptions,
    familyOptions,
    labeledFamilyOptions,
    searchProductionPlanData,
  } = useProductionPlanSupplierContext();
  const [draftFilters, setDraftFilters] = useState<ProductionPlanSupplierFilters>(filters);

  useEffect(() => {
    setDraftFilters(filters);
  }, [filters]);

  const handleFilterChange = function handleFilterChange<
    T extends keyof ProductionPlanSupplierFilters,
  >(field: T, value: ProductionPlanSupplierFilters[T]) {
    setDraftFilters((current) => ({
      ...current,
      [field]: value,
    }));
  };

  const handleApplyFilters = async () => {
    await searchProductionPlanData({
      ...draftFilters,
      _page: 0,
    });
  };

  return (
    <S.FilterPanel>
      <ProductionPlanSupplierFilterFields
        filters={draftFilters}
        supplierOptions={supplierOptions}
        materialOptions={materialOptions}
        familyOptions={familyOptions}
        labeledFamilyOptions={labeledFamilyOptions}
        onChange={handleFilterChange}
        filterOptionsLoading={filterOptionsLoading}
      />

      <S.FilterActions>
        <Button
          buttonType="primary"
          onClick={handleApplyFilters}
          value={intl.get("filters.filter")}
          className="button-filter-production-plan-supplier"
        />
      </S.FilterActions>
    </S.FilterPanel>
  );
};

export default ProductionPlanSupplierFilter;
